import { useTranslation } from "react-i18next";
import { SelectInput } from "../SelectInput";
import useLanguageSelector from "../../hooks/useLanguageSelector";
import { UseFormRegisterReturn } from "react-hook-form";
import styles from "./LanguageSelector.module.css";

interface LanguageSelectorProps {
  register?: UseFormRegisterReturn;
  defaultValue?: string;
  error?: string;
  width?: string;
  isDisabled?: boolean;
}

export function LanguageSelector({
  register,
  defaultValue,
  error,
  width = "20rem",
  isDisabled = false,
}: LanguageSelectorProps) {
  const { t } = useTranslation();
  const { inputLanguageOptions } = useLanguageSelector();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (register?.onChange) {
      register.onChange(e);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>{t("language")}</h1>
        <p className={styles.description}>{t("languageDescription")}</p>
      </div>

      <div className={styles.content}>
        <SelectInput
          title={t("language")}
          variant="resized"
          placeholder={t("selectAnOption")}
          options={inputLanguageOptions}
          defaultValue={defaultValue || ""}
          error={error}
          width={width}
          disabled={isDisabled}
          onChange={handleChange}
          name={register?.name}
          ref={register?.ref}
        />
      </div>
    </div>
  );
}
